import { Message } from "./Message";

## Basic Usage

<Message>This is a default message.</Message>

---

## Message Types

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <Message messageType="default">Default message</Message>
  <Message messageType="info">Info: Here's some helpful information.</Message>
  <Message messageType="success">Success: Your changes have been saved.</Message>
  <Message messageType="warning">Warning: Please review before continuing.</Message>
  <Message messageType="error">Error: Something went wrong.</Message>
</div>

---

## Variants

### Standard Variant

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <Message variant="standard" messageType="info">Standard info message</Message>
  <Message variant="standard" messageType="success">Standard success message</Message>
  <Message variant="standard" messageType="warning">Standard warning message</Message>
  <Message variant="standard" messageType="error">Standard error message</Message>
</div>

### Inverted Variant (Default)

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <Message variant="inverted" messageType="info">Inverted info message</Message>
  <Message variant="inverted" messageType="success">Inverted success message</Message>
  <Message variant="inverted" messageType="warning">Inverted warning message</Message>
  <Message variant="inverted" messageType="error">Inverted error message</Message>
</div>

### Banner Variant

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <Message variant="banner" messageType="info">Banner style info message</Message>
  <Message variant="banner" messageType="warning">Banner style warning message</Message>
</div>

---

## Dismissable Messages

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <Message messageType="info" dismissable>
    Click the X to dismiss this message.
  </Message>
  <Message messageType="success" dismissable>
    This success message can be dismissed.
  </Message>
</div>

---

## Centered Content

<Message messageType="info" centered>
  This message content is centered.
</Message>

---

## Sticky Message

<Message messageType="warning" sticky>
  This message has sticky positioning enabled.
</Message>

---

## With Margin Bottom

<div>
  <Message messageType="info" marginBottom>
    This message has margin below it.
  </Message>
  <p>Content after the message.</p>
</div>

---

## Use Cases

### Form Validation Error

<div style={{ maxWidth: "400px" }}>
  <Message messageType="error">
    Please correct the following errors:
    <ul style={{ margin: "0.5rem 0 0", paddingLeft: "1.5rem" }}>
      <li>Email address is required</li>
      <li>Password must be at least 8 characters</li>
    </ul>
  </Message>
</div>

### Success Confirmation

<Message messageType="success" dismissable>
  Your profile has been updated successfully!
</Message>

### Warning Notice

<Message messageType="warning">
  Your subscription will expire in 3 days. <a href="#" style={{ color: "inherit", fontWeight: 500 }}>Renew now</a>
</Message>

### System Status

<Message variant="banner" messageType="info">
  Scheduled maintenance will occur on Saturday from 2:00 AM - 4:00 AM UTC.
</Message>


